import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import ApiMServer from "../../services/ApiMServer";
import { FaEnvelope, FaUser, FaPhone, FaBuilding, FaIdCard, FaLock, FaGlobe, FaArrowLeft } from 'react-icons/fa';

const Register = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    fone: '',
    empresa: '',
    cpfcnpj: '',
    password: '',
    confirmPassword: '',
    termos: false,
    country: 'BRASIL'
  });
  const [error, setError] = useState('');

  const handleRegister = async () => {
    if (!formData.name || !formData.email || !formData.fone || !formData.empresa || !formData.cpfcnpj || !formData.password || !formData.confirmPassword) {
      setError('Por favor, preencha todos os campos.');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }

    if (!formData.termos) {
      setError('Você deve aceitar os termos de uso.');
      return;
    }

    try {
      await ApiMServer.post(`/register`, formData);
      navigate('/');
    } catch (error) {
      console.log(error);
      setError(error?.response?.data || 'Erro ao registrar usuário.');
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
    setError('');
  };

  const handleCPFChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 11) value = value.slice(0, 11);

    // Aplica a máscara no formato CPF: 000.000.000-00
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

    setFormData((prevData) => ({
      ...prevData,
      cpfcnpj: value,
    }));
    setError('');
  };

  const goToLogin = () => {
    navigate('/');
  };

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${'./images/capa.png'})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Container
        className="p-4 border rounded-lg shadow"
        style={{
          maxWidth: '800px',
          backgroundColor: 'rgba(255, 255, 255, 0.65)',
          backdropFilter: 'blur(12px)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.18)',
          boxShadow: '0 8px 32px 0 rgba(28, 66, 32, 0.37)',
          transition: 'all 0.3s ease'
        }}
      >
        <div className="text-center mb-4">
          <img 
            src="./images/logo.png" 
            alt="Logo" 
            style={{ maxHeight: '60px', marginBottom: '15px' }} 
            className="img-fluid"
          />
          <h2 className="fw-bold" style={{ color: '#1c4220' }}>Registrar Conta</h2>
          <p className="text-muted">Preencha os dados para criar sua conta</p>
        </div>

        <Form>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Form.Label className="d-flex align-items-center mb-1 fw-bold" style={{ color: '#1c4220' }}>
                  <FaUser className="me-2" /> Nome
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Digite seu nome completo"
                  value={formData.name}
                  onChange={handleInputChange}
                  style={{ 
                    padding: '12px 20px',
                    background: 'rgba(255, 255, 255, 0.5)',
                    backdropFilter: 'blur(5px)',
                    border: '1px solid rgba(143, 173, 21, 0.3)',
                    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px'
                  }}
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Form.Label className="d-flex align-items-center mb-1 fw-bold" style={{ color: '#1c4220' }}>
                  <FaEnvelope className="me-2" /> E-mail
                </Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Digite seu e-mail"
                  value={formData.email}
                  onChange={handleInputChange}
                  style={{ 
                    padding: '12px 20px',
                    background: 'rgba(255, 255, 255, 0.5)',
                    backdropFilter: 'blur(5px)',
                    border: '1px solid rgba(143, 173, 21, 0.3)',
                    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px'
                  }}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Form.Label className="d-flex align-items-center mb-1 fw-bold" style={{ color: '#1c4220' }}>
                  <FaPhone className="me-2" /> Telefone
                </Form.Label>
                <Form.Control
                  type="text"
                  name="fone"
                  placeholder="Digite seu telefone"
                  value={formData.fone}
                  onChange={handleInputChange}
                  style={{ 
                    padding: '12px 20px',
                    background: 'rgba(255, 255, 255, 0.5)',
                    backdropFilter: 'blur(5px)',
                    border: '1px solid rgba(143, 173, 21, 0.3)',
                    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px'
                  }}
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Form.Label className="d-flex align-items-center mb-1 fw-bold" style={{ color: '#1c4220' }}>
                  <FaBuilding className="me-2" /> Empresa
                </Form.Label>
                <Form.Control
                  type="text"
                  name="empresa"
                  placeholder="Digite o nome da empresa"
                  value={formData.empresa}
                  onChange={handleInputChange}
                  style={{ 
                    padding: '12px 20px',
                    background: 'rgba(255, 255, 255, 0.5)',
                    backdropFilter: 'blur(5px)',
                    border: '1px solid rgba(143, 173, 21, 0.3)',
                    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px'
                  }}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Form.Label className="d-flex align-items-center mb-1 fw-bold" style={{ color: '#1c4220' }}>
                  <FaIdCard className="me-2" /> CPF
                </Form.Label>
                <Form.Control
                  type="text"
                  name="cpfcnpj"
                  placeholder="Digite seu CPF"
                  value={formData.cpfcnpj}
                  onChange={handleCPFChange}
                  style={{ 
                    padding: '12px 20px',
                    background: 'rgba(255, 255, 255, 0.5)',
                    backdropFilter: 'blur(5px)',
                    border: '1px solid rgba(143, 173, 21, 0.3)',
                    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px'
                  }}
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Form.Label className="d-flex align-items-center mb-1 fw-bold" style={{ color: '#1c4220' }}>
                  <FaGlobe className="me-2" /> País
                </Form.Label>
                <div
                  style={{ 
                    padding: '12px 20px',
                    background: 'rgba(255, 255, 255, 0.5)',
                    backdropFilter: 'blur(5px)',
                    border: '1px solid rgba(143, 173, 21, 0.3)',
                    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <Form.Check
                    type="radio"
                    id="paisBrasil"
                    name="country"
                    label="BRASIL"
                    value="BRASIL"
                    checked={formData.country === 'BRASIL'}
                    onChange={handleInputChange}
                    className="me-4"
                    style={{ marginBottom: 0 }}
                  />
                  <Form.Check
                    type="radio"
                    id="paisOutros"
                    name="country"
                    label="Outro"
                    value="Outro"
                    checked={formData.country === 'Outro'}
                    onChange={handleInputChange}
                    style={{ marginBottom: 0 }}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Form.Label className="d-flex align-items-center mb-1 fw-bold" style={{ color: '#1c4220' }}>
                  <FaLock className="me-2" /> Senha
                </Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  placeholder="Digite sua senha"
                  value={formData.password}
                  onChange={handleInputChange}
                  style={{ 
                    padding: '12px 20px',
                    background: 'rgba(255, 255, 255, 0.5)',
                    backdropFilter: 'blur(5px)',
                    border: '1px solid rgba(143, 173, 21, 0.3)',
                    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px'
                  }}
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Form.Label className="d-flex align-items-center mb-1 fw-bold" style={{ color: '#1c4220' }}>
                  <FaLock className="me-2" /> Confirmar Senha
                </Form.Label>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirme sua senha"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  style={{ 
                    padding: '12px 20px',
                    background: 'rgba(255, 255, 255, 0.5)',
                    backdropFilter: 'blur(5px)',
                    border: '1px solid rgba(143, 173, 21, 0.3)',
                    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px'
                  }}
                />
              </div>
            </Col>
          </Row>

          <Row className="mb-4 mt-2">
            <Col>
              <Form.Check
                type="checkbox"
                id="termos"
                name="termos"
                checked={formData.termos}
                onChange={handleInputChange}
                label={<>Aceito os <a href="/termos-de-uso" style={{color: '#1c4220'}} rel="noopener noreferrer">termos de uso</a></>}
              />
            </Col>
          </Row>

          {error && 
            <Alert 
              className="p-2 mb-3" 
              variant="danger"
              style={{ 
                fontSize: '0.9rem',
                background: 'rgba(220, 53, 69, 0.7)',
                backdropFilter: 'blur(5px)',
                border: '1px solid rgba(220, 53, 69, 0.2)',
                color: 'white',
                borderRadius: '10px'
              }}
            >
              {error}
            </Alert>
          }

          <Row>
            <Col md={6}>
              <Button
                variant="success"
                className="w-100 py-2 mb-3 fw-bold"
                onClick={handleRegister}
                style={{ 
                  background: 'linear-gradient(135deg, rgba(143, 173, 21, 0.9), rgba(28, 66, 32, 0.9))',
                  border: 'none',
                  backdropFilter: 'blur(5px)',
                  boxShadow: '0 4px 15px rgba(28, 66, 32, 0.3)',
                  borderRadius: '10px',
                  transition: 'all 0.3s ease'
                }}
              >
                Registrar Conta
              </Button>
            </Col>
            <Col md={6}>
              <Button
                variant="link"
                className="w-100 text-center d-flex align-items-center justify-content-center"
                onClick={goToLogin}
                style={{ 
                  color: '#1c4220',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                <FaArrowLeft className="me-2" />
                Voltar para o Login
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </Container>
  );
};

export default Register;
